import { IClassMap } from "./helpers";

enum JustifyContent {
    Start = 'Start',
    Center = 'Center',    
    End = 'End',
    Between = 'Between',
    Around = 'Around',
    Evenly = 'Evenly'
}

const mergeJustifyContent = (cssClasses: IClassMap, justifyContent?: JustifyContent) : IClassMap => {
    return { ...cssClasses,
        'justify-content-start': justifyContent === JustifyContent.Start,
        'justify-content-center': justifyContent === JustifyContent.Center,
        'justify-content-end': justifyContent === JustifyContent.End,
        'justify-content-between': justifyContent === JustifyContent.Between,
        'justify-content-around': justifyContent === JustifyContent.Around,
        'justify-content-evenly': justifyContent === JustifyContent.Evenly
    };
}

const JustifyContentValues = {
    [JustifyContent.Start]: 'justify-content-start',
    [JustifyContent.Center]: 'justify-content-center',
    [JustifyContent.End]: 'justify-content-end',
    [JustifyContent.Between]: 'justify-content-between',
    [JustifyContent.Around]: 'justify-content-around',
    [JustifyContent.Evenly]: 'justify-content-evenly'
};
export { JustifyContent, JustifyContentValues, mergeJustifyContent };